//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "MoveOutSummary",
	props: {
		resident: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			step: 1,
			modalName: 'move-out-summary',
			modifyReason: 'Resident Request',
			addForwarding: false,
			addCharge: false,
			showReletFee: false,
			showLoader: {
				cancelMoveout: false
			},
			moveoutReasons: [],
			noticeEvent: {
				notice: {
					residentId: null,
					moveout_reason_id: null,
					notify_type: "moveout",
					notify_date: moment().format("MM/DD/YYYY"),
					estimated_moveout_date: "",
					address_one: "",
					address_two: "",
					city: "",
					state: "",
					zip: "",
					pro_rate_transactions: [],
					relet_fee: 0
				},
				resident: {},
				pro_rate_transactions: [],
				recurring_transactions: []
			},
			moveOutEvent: {},
			applyProrates: false,
			chargeType: 'credit',
			charges: [],
			accountingChargeCodes: [],
			newTransaction: {},
			currentRentAmount: 0,
			preventAllPortal: false,
			preventPayPortal: false,
			selectedMoveoutReason: {},
			viewHistory: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.noticeEvent.residentId = this.resident.id;

		Event.$on('close-full-modal', function () {
			Object.assign(_this.$data, _this.$options.data());
		});

		Event.$on('moveout-summary', function () {
			_this.getMoveOutEvent();
			_this.getNoticeEvent(_this.resident.latest_notice_event.id_notice_events);
			Event.$emit('open-slide', _this.modalName);
		});

		Event.$on('cancel-move-out', function () {
			_this.cancelMoveOut();
		});
	},

	computed: {
		residentForwardingAddress: function residentForwardingAddress() {
			var address = this.resident.address_one;
			if (address) {
				return address.concat('<br/>' + (this.resident.address_two ? this.resident.address_two + ', ' : '') + this.resident.city, '<br/>' + this.resident.state + ', ' + this.resident.zip);
			}
			return '';
		},
		totalTransactions: function totalTransactions() {
			// I believe this is now cruft on this component, as label removed
			if (!this.noticeEvent.pro_rate_transactions && !this.noticeEvent.relet_fee) return 0;

			var total = 0;
			var relet = this.noticeEvent.relet_fee ? this.noticeEvent.relet_fee : 0;
			this.noticeEvent.pro_rate_transactions.forEach(function (item) {
				total += item.prorated_amount;
			});

			return total + relet;
		},
		recurringCharges: function recurringCharges() {
			return this.noticeEvent.recurring_transactions.filter(function (item) {
				return item.type === 'Recurring';
			});
		},

		hasRecurringCharges: function hasRecurringCharges() {
			return this.recurringCharges.length;
		},
		oneTimeCharges: function oneTimeCharges() {
			if (!this.noticeEvent || !this.noticeEvent.pro_rate_transactions) {
				return [];
			}

			return this.noticeEvent.pro_rate_transactions.filter(function (item) {
				return item.type === 'One-Time';
			});
		},

		hasOneTimeCharges: function hasOneTimeCharges() {
			return this.oneTimeCharges.length;
		}
	},
	methods: {
		// @NOTE: this calls <new-resident-slide-out-cancel> with props, one of which is to call `cancel-move-out`
		// which will actually cancel the MoveOutEvent
		cancel: function cancel() {
			Event.$emit('cancel-notice');
		},
		getNoticeEvent: function getNoticeEvent(noticeEventId) {
			var _this2 = this;

			return axios.get("/prototype/person/residents/notice-events/" + noticeEventId + "/" + this.moveOutEvent.moveout_date).then(function (response) {
				if (response.data.error) {
					_this2.$snotify.error("Error pulling notice event: " + response.data.error);
				} else {
					_this2.noticeEvent = response.data;
					_this2.selectedMoveoutReason = {
						value: _this2.noticeEvent.notice.move_out_reason ? _this2.noticeEvent.notice.move_out_reason.id : -1,
						label: _this2.noticeEvent.notice.move_out_reason ? _this2.noticeEvent.notice.move_out_reason.name : ''
					};
					_this2.noticeEvent.notice.notify_date = moment(_this2.noticeEvent.notice.notify_date).format('MM/DD/YYYY');
					_this2.noticeEvent.notice.estimated_moveout_date = moment(_this2.noticeEvent.notice.estimated_moveout_date).format('MM/DD/YYYY');
					_this2.noticeEvent.notice.updated_at = moment(_this2.noticeEvent.notice.updated_at).format('MM/DD/YYYY');
				}
			});
		},
		getMoveOutEvent: function getMoveOutEvent() {
			this.moveOutEvent = this.resident.latest_move_out_event;
			this.moveOutEvent.moveout_date = moment(this.moveOutEvent.moveout_date).format('MM-DD-YYYY');
		},
		cancelMoveOut: function cancelMoveOut() {
			var _this3 = this;

			this.showLoader.cancelMoveout = true;
			axios.delete('/prototype/person/residents/move-outs/' + this.moveOutEvent.id_move_out_events).then(function (response) {
				_this3.showLoader.cancelMoveout = false;
				if (response.data.error) {
					_this3.$snotify.error("Error deleting move out event: " + response.data.error);
				} else {
					Event.$emit('close-slide', _this3.modalName);
					Event.$emit('refresh-resident-dashboard', _this3.resident);
				}
			});
		},
		calculateProrateAmount: function calculateProrateAmount(price) {
			var estimated_moveout_date = moment(this.noticeEvent.notice.estimated_moveout_date, 'MM/DD/YYYY');

			var startOfMonth = estimated_moveout_date.clone();
			startOfMonth = moment(startOfMonth).startOf('month').format('YYYY-MM-DD');

			var days = estimated_moveout_date.diff(startOfMonth, 'days') + 1;
			var daysInMonth = estimated_moveout_date.daysInMonth();
			return (price / daysInMonth * days).toFixed(2);
		},
		calculateProrates: function calculateProrates() {
			var _this4 = this;

			this.charges.map(function (charge) {
				if (charge.ar_transaction_recurring_id) {
					charge.amount = _this4.calculateProrateAmount(charge.original_amount);
				}
			});
		},
		dateFilter: function dateFilter(value) {
			if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY');
		}
	},
	watch: {
		showReletFee: function showReletFee() {
			if (this.showReletFee) {
				var rent = this.charges.find(function (charge) {
					return charge.name.toLowerCase() == 'rent';
				});
				if (rent) {
					this.currentRentAmount = rent.original_amount;
					if (this.noticeEvent.notice.relet_fee && this.noticeEvent.notice.relet_fee <= 0) {
						this.noticeEvent.notice.relet_fee = (rent.original_amount * .85).toFixed(2);
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/move-outs/MoveOutSummary.vue
// module id = fv1U
// module chunks = 0 1